import { gorillaObjects, typeFaceEnObjs, typeFaceJaObjs } from 'src/features/gorilla/constants/embroidery'
import { Embroidery, EmbroideryKey, PartialActionDispatch, Position, StateObj } from 'src/types'
import { isHalfWidthCharChecker } from 'src/logic'
import { positionChecker } from 'src/logic'
import { useEmbroideryContent } from 'src/hooks/useEmbroideryContent'
import { useEmbroideriesDispatcher } from 'src/hooks/useEmbroideriesDispatcher'

const gorillaEmbroideriesDispatcher = (dispatch: PartialActionDispatch, embroideries: Embroidery[], key: EmbroideryKey) => {
  return (selected: string, i?: number) => useEmbroideriesDispatcher(dispatch, embroideries, selected, gorillaObjects, key, i)
}

export const useGorillaEmbroideriesDispatchGenerator = (dispatch: PartialActionDispatch, embroideries: Embroidery[]) => {
  const handleContentAndNum = useEmbroideryContent(dispatch, embroideries)
  return {
    handle: {
      typeFace: gorillaEmbroideriesDispatcher(dispatch, embroideries, 'typeFace'),
      position: gorillaEmbroideriesDispatcher(dispatch, embroideries, 'position'),
      color: gorillaEmbroideriesDispatcher(dispatch, embroideries, 'color'),
      shadowColor: gorillaEmbroideriesDispatcher(dispatch, embroideries, 'shadowColor'),
      edgeColor: gorillaEmbroideriesDispatcher(dispatch, embroideries, 'edgeColor'),
      content: (selected: string, i?: number) => {
        if (i === undefined) return
        handleContentAndNum(selected, i)
      }
    }
  }
}

export const characterCheckHelper = (contentStr: string) => {
  const isHalfWidthChar = isHalfWidthCharChecker(contentStr)
  const isJapanese = contentStr.charCodeAt(0) >= 256
  const typeFaceObjects = isJapanese ? typeFaceJaObjs : typeFaceEnObjs
  return {
    contentMaxLength: isHalfWidthChar ? 12 : 12,
    existsContent: contentStr.length > 0,
    typeFaceObjects
  }
}

export const selectableChecker = (series: StateObj, position: Position): boolean => {
  const { isPitcher } = positionChecker(position)
  return series?.value !== 'unselected' || !isPitcher
}
